import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  border-radius: 24px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  box-shadow: 0 16px #ffffff;
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 16px #ffffff, 0 0 16px 1px #0e121b1a,
      0 16px 16px 1px #0e121b1a;
  }

  ${({ $inHeader = false }) =>
    $inHeader &&
    css`
      box-shadow: none !important;
    `}
`;

export const Content = styled.div`
  padding: 20px 12px 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex-grow: 1;

  @media ${({ theme }) => theme.media.mobile} {
    width: 100%;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;

  img {
    width: 100%;
    height: 280px;
    object-fit: cover;
    border-radius: 24px;
  }

  @media ${({ theme }) => theme.media.mobile} {
    width: 100%;
  }
`;

export const Tag = styled.div`
  position: absolute;
  left: 12px;
  bottom: 12px;
  padding: 2px 12px;
  width: fit-content;
  max-width: calc(100% - 12px - 12px);
  height: fit-content;
  min-height: 25px;
  border-radius: 32px;
  background: rgba(29, 29, 29, 0.6);
  backdrop-filter: blur(30px);
  color: #ffffff;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  cursor: pointer;
  transition: background 0.3s ease;

  &:hover {
    background: rgba(29, 29, 29, 0.9);
  }
`;

export const Title = styled.div`
  margin-bottom: 16px;
  width: fit-content;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: 500;
  font-size: 24px;
  line-height: 150%;
  color: rgba(29, 29, 29, 0.85);
  cursor: pointer;
  /* display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis; */

  &:hover {
    text-decoration: underline;
  }

  ${({ $inHeader = false }) =>
    $inHeader &&
    css`
      white-space: normal;
      text-align: left;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
`;

export const Meta = styled.div`
  margin-top: auto;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;

  &,
  * {
    font-family: ${({ theme }) => theme.fonts.primary};
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    color: rgba(29, 29, 29, 0.5);
  }
`;

export const MetaSpan = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;

  img {
    width: 16px;
    height: 16px;
  }
`;

export const MetaSeparator = styled.span`
  width: 4px;
  height: 4px;
  background: rgba(29, 29, 29, 0.5);
  border-radius: 50%;
`;
